import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import HeaderWithIcons from './HeaderWithIcons';

export default function Privacy() {
	const {t} = useTranslation();
	return (<>
		<HeaderWithIcons title={t('privacy')}/>
		<div className="flex flex-col space-y-2 px-4">
			<Typography className="text-justify">{t('privacy_description')}</Typography>
		</div>
	</>);
}
